import styled from 'styled-components';

const LoginPagePBody = styled.body`
    display: grid;
    height: 0vh;
    width: 100%;
    place-items: center;
    background: -webkit-linear-gradient(left, #FF4B2B, #FF416C); 
`;
const LoginPagePHtml = styled.html`
    display: grid;
    height: 0vh;
    width: 100%;
    place-items: center;
    background: -webkit-linear-gradient(left, #FF4B2B, #FF416C); 
`;

export { LoginPagePBody, LoginPagePHtml };